import { useQuery } from '@tanstack/react-query'
import { getAnalyticsDigest, type AnalyticsPeriodParams } from '../../shared/api/analytics.api'

/**
 * Сводный «светофор» модуля «Аналитика» (этап 6 docs/analytics-plan.md).
 * Баннер над вкладками: главные алёрты по системе за выбранный период.
 */
export function DigestBanner({ periodParams }: { periodParams: AnalyticsPeriodParams }) {
  const { data } = useQuery({
    queryKey: ['analytics-digest', periodParams],
    queryFn: () => getAnalyticsDigest(periodParams),
  })

  if (!data) return null

  if (data.alerts.length === 0) {
    return (
      <div className="flex items-center gap-2 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-2.5 text-sm text-emerald-700">
        <span className="h-2 w-2 rounded-full bg-emerald-500" />
        Критичных проблем не обнаружено.
      </div>
    )
  }

  return (
    <div className="rounded-xl border border-gray-200 bg-white px-4 py-3">
      <div className="text-xs font-medium text-gray-500 mb-2">Сводка — требует внимания</div>
      <div className="space-y-1.5">
        {data.alerts.map((a, i) => (
          <div key={i} className="flex items-start gap-2 text-sm text-gray-800">
            <span
              className={`mt-1.5 h-2 w-2 rounded-full flex-shrink-0 ${
                a.level === 'red' ? 'bg-red-500' : 'bg-amber-500'
              }`}
            />
            {a.text}
          </div>
        ))}
      </div>
    </div>
  )
}
